import RequireAuth from '../Components/RequireAuth';
import {Routes, Route} from 'react-router-dom';
import ViewArticles from './Articles/Articles';
import AddArticle from './Articles/AddArticle';
import Article from './Articles/Article';

function Articles({img, cat}) {
  return (
    <Routes>
      <Route exact path='/' element={<ViewArticles img={img} cat={cat}/>} />
      <Route exact path='/view/:id' element={<Article img={img} cat={cat}/>} />       
      <Route element={<RequireAuth allowedRoles={[3, 4, 5]} />}>
        <Route exact path='/add' element={<AddArticle img={img} cat={cat}/>}/>
      </Route>
    </Routes>
  )
}

export default Articles